import * as React from 'react';

// Regras de formatação aplicadas às mensagens da T.I.A, em ordem.
// Para adicionar uma nova: inclua um item com `pattern` (regex com flag `g`)
// e `render`, que recebe o match e devolve o elemento no lugar do trecho.
// Regras posteriores só atuam sobre o texto que as anteriores não formataram.
const RULES = [
  {
    // **texto** → negrito
    pattern: /\*\*(.+?)\*\*/g,
    render: match => <strong>{match[1]}</strong>
  }
];

function applyRule(text, { pattern, render }) {
  const nodes = [];
  let lastIndex = 0;

  for (const match of text.matchAll(pattern)) {
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
    nodes.push(render(match));
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes;
}

export function formatTiaMessage(text = '') {
  const nodes = RULES.reduce((acc, rule) => acc.flatMap(node => (typeof node === 'string' ? applyRule(node, rule) : node)), [text]);

  return nodes.map((node, index) => <React.Fragment key={index}>{node}</React.Fragment>);
}
